var _rect, _rect2, _rect3, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomSubtasks = function SvgCustomSubtasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(90 18 9)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(90 18 17)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(-90 3 7)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6v9c0 1.886 0 2.828.586 3.414C6.172 19 7.114 19 9 19h5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7c0 1.886 0 2.828.586 3.414C6.172 11 7.114 11 9 11h5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};

export default SvgCustomSubtasks;